function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import View from './view';
import Viewport from '../viewports/viewport'; // TODO - use math.gl

import { createMat4, transformVector } from '../utils/math-utils';
import mat4_multiply from 'gl-mat4/multiply';
import mat4_lookAt from 'gl-mat4/lookAt';
import mat4_scale from 'gl-mat4/scale';
import mat4_perspective from 'gl-mat4/perspective';
import mat4_translate from 'gl-mat4/translate';
import mat4_rotateX from 'gl-mat4/rotateX';
import mat4_rotateY from 'gl-mat4/rotateY';
import mat4_rotateZ from 'gl-mat4/rotateZ';
import OrbitController from '../controllers/orbit-controller';
var DEGREES_TO_RADIANS = Math.PI / 180; // TODO - remove need for custom project overrides

var OrbitViewport =
/*#__PURE__*/
function (_Viewport) {
  _inherits(OrbitViewport, _Viewport);

  function OrbitViewport() {
    _classCallCheck(this, OrbitViewport);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrbitViewport).apply(this, arguments));
  }

  _createClass(OrbitViewport, [{
    key: "project",
    value: function project(xyz) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$topLeft = _ref.topLeft,
          topLeft = _ref$topLeft === void 0 ? false : _ref$topLeft;

      var v = transformVector(this.pixelProjectionMatrix, _toConsumableArray(xyz).concat([1]));

      var _v = _slicedToArray(v, 3),
          x = _v[0],
          y = _v[1],
          z = _v[2];

      var y2 = topLeft ? this.height - y : y;
      return [x, y2, z];
    }
  }, {
    key: "unproject",
    value: function unproject(xyz) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$topLeft = _ref2.topLeft,
          topLeft = _ref2$topLeft === void 0 ? false : _ref2$topLeft;

      var _xyz = _slicedToArray(xyz, 3),
          x = _xyz[0],
          y = _xyz[1],
          z = _xyz[2];

      var y2 = topLeft ? this.height - y : y;
      return transformVector(this.pixelUnprojectionMatrix, [x, y2, z, 1]);
    }
  }]);

  return OrbitViewport;
}(Viewport);

var OrbitView =
/*#__PURE__*/
function (_View) {
  _inherits(OrbitView, _View);

  function OrbitView() {
    _classCallCheck(this, OrbitView);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrbitView).apply(this, arguments));
  }

  _createClass(OrbitView, [{
    key: "_getViewport",

    /* eslint-disable complexity, max-statements */
    value: function _getViewport(props) {
      var viewState = props.viewState;
      var width = props.width || 1;
      var height = props.height || 1; // Get view matrix parameters from view state
      // Projection matrix arguments
      // TODO - Extracting from viewState is deprecated

      var fovy = props.fov || props.fovy || viewState.fovy || 75; // Field of view covered by camera

      var near = props.near || viewState.near || 1; // Distance of near clipping plane

      var far = props.far || viewState.far || 100; // Distance of far clipping plane

      var aspect = Number.isFinite(viewState.aspect) ? viewState.aspect : width / height;
      var fovyRadians = fovy * DEGREES_TO_RADIANS;
      return new OrbitViewport({
        id: this.id,
        viewMatrix: this._getViewMatrix(props.viewState),
        projectionMatrix: mat4_perspective([], fovyRadians, aspect, near, far),
        x: props.x,
        y: props.y,
        width: width,
        height: height
      });
    }
    /* eslint-enable complexity, max-statements */

  }, {
    key: "_getViewMatrix",
    value: function _getViewMatrix(viewState) {
      var distance = viewState.distance,
          _viewState$rotationX = viewState.rotationX,
          rotationX = _viewState$rotationX === void 0 ? 0 : _viewState$rotationX,
          _viewState$rotationOr = viewState.rotationOrbit,
          rotationOrbit = _viewState$rotationOr === void 0 ? 0 : _viewState$rotationOr,
          _viewState$orbitAxis = viewState.orbitAxis,
          orbitAxis = _viewState$orbitAxis === void 0 ? 'Z' : _viewState$orbitAxis,
          _viewState$lookAt = viewState.lookAt,
          lookAt = _viewState$lookAt === void 0 ? [0, 0, 0] : _viewState$lookAt,
          _viewState$up = viewState.up,
          up = _viewState$up === void 0 ? [0, 1, 0] : _viewState$up,
          _viewState$zoom = viewState.zoom,
          zoom = _viewState$zoom === void 0 ? 1 : _viewState$zoom;
      var rotationMatrix = mat4_rotateX([], createMat4(), -rotationX / 180 * Math.PI);

      if (orbitAxis === 'Z') {
        mat4_rotateZ(rotationMatrix, rotationMatrix, -rotationOrbit / 180 * Math.PI);
      } else {
        mat4_rotateY(rotationMatrix, rotationMatrix, -rotationOrbit / 180 * Math.PI);
      }

      var translateMatrix = createMat4();
      mat4_scale(translateMatrix, translateMatrix, [zoom, zoom, zoom]);
      mat4_translate(translateMatrix, translateMatrix, [-lookAt[0], -lookAt[1], -lookAt[2]]);
      var viewMatrix = mat4_lookAt([], [0, 0, distance], [0, 0, 0], up);
      mat4_multiply(viewMatrix, viewMatrix, mat4_multiply(rotationMatrix, rotationMatrix, translateMatrix));
      return viewMatrix;
    }
    /** Move camera to make a model bounding box centered at lookat position fit in the viewport.
     * @param {Array} boundingBox - [sizeX, sizeY, sizeZ]], define the dimensions of bounding box
     * @returns a new OrbitViewport object
     */

  }, {
    key: "fitBounds",
    value: function fitBounds(boundingBox, viewState) {
      var width = this.width,
          height = this.height,
          fov = this.fov,
          near = this.near,
          far = this.far;
      return this._getViewport({
        width: width,
        height: height,
        fov: fov,
        near: near,
        far: far
      });
    }
  }, {
    key: "controller",
    get: function get() {
      return this._getControllerProps({
        type: OrbitController
      });
    }
  }], [{
    key: "getDistance",
    // Get camera `distance` to make view fit a box centered at lookat position in the viewport.
    // @param {Array} boundingBox - [sizeX, sizeY, sizeZ]], defines the dimensions of bounding box
    value: function getDistance(_ref3) {
      var boundingBox = _ref3.boundingBox,
          fov = _ref3.fov;
      var halfMaxSide = Math.max(boundingBox[0], boundingBox[1], boundingBox[2]) / 2;
      var distance = halfMaxSide / Math.tan(fov / 180 * Math.PI / 2);
      return distance;
    }
  }]);

  return OrbitView;
}(View);

export { OrbitView as default };
OrbitView.displayName = 'OrbitView';
//# sourceMappingURL=orbit-view.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/core/dist/esm/views/orbit-view.js
// module id = 926
// module chunks = 0